export const theme = {
  colors: {
    background: '#0f0f0f',
    surface: '#1a1a2e',
    primary: '#38bdf8',
    text: '#ffffff',
    textMuted: '#94a3b8',
    border: 'rgba(56, 189, 248, 0.3)',
    error: '#f87171',
    success: '#4ade80',
    glowStrong: 'rgba(56, 189, 248, 0.1)',
    glowSubtle: 'rgba(56, 189, 248, 0.06)',
  },
};

export default theme;
